/**
 * Countries and Country Codes
 * Used for phone number selection and country dropdown
 */

export const COUNTRY_CODES = [
  { code: '+1', country: 'United States', countryName: 'US', minDigits: 10, maxDigits: 10, example: '2025551234' },
  { code: '+1', country: 'Canada', countryName: 'CA', minDigits: 10, maxDigits: 10, example: '4165551234' },
  { code: '+44', country: 'United Kingdom', countryName: 'GB', minDigits: 10, maxDigits: 11, example: '2071838750' },
  { code: '+91', country: 'India', countryName: 'IN', minDigits: 10, maxDigits: 10, example: '9876543210' },
  { code: '+61', country: 'Australia', countryName: 'AU', minDigits: 9, maxDigits: 9, example: '291234567' },
  { code: '+81', country: 'Japan', countryName: 'JP', minDigits: 9, maxDigits: 11, example: '9012345678' },
  { code: '+86', country: 'China', countryName: 'CN', minDigits: 11, maxDigits: 11, example: '13912345678' },
  { code: '+33', country: 'France', countryName: 'FR', minDigits: 9, maxDigits: 9, example: '123456789' },
  { code: '+49', country: 'Germany', countryName: 'DE', minDigits: 10, maxDigits: 13, example: '30123456789' },
  { code: '+39', country: 'Italy', countryName: 'IT', minDigits: 10, maxDigits: 10, example: '3312345678' },
  { code: '+34', country: 'Spain', countryName: 'ES', minDigits: 9, maxDigits: 9, example: '912345678' },
  { code: '+31', country: 'Netherlands', countryName: 'NL', minDigits: 9, maxDigits: 9, example: '612345678' },
  { code: '+41', country: 'Switzerland', countryName: 'CH', minDigits: 9, maxDigits: 9, example: '791234567' },
  { code: '+43', country: 'Austria', countryName: 'AT', minDigits: 10, maxDigits: 13, example: '6501234567' },
  { code: '+46', country: 'Sweden', countryName: 'SE', minDigits: 9, maxDigits: 9, example: '701234567' },
  { code: '+47', country: 'Norway', countryName: 'NO', minDigits: 8, maxDigits: 8, example: '98765432' },
  { code: '+45', country: 'Denmark', countryName: 'DK', minDigits: 8, maxDigits: 8, example: '40123456' },
  { code: '+358', country: 'Finland', countryName: 'FI', minDigits: 9, maxDigits: 12, example: '401234567' },
  { code: '+353', country: 'Ireland', countryName: 'IE', minDigits: 9, maxDigits: 9, example: '851234567' },
  { code: '+32', country: 'Belgium', countryName: 'BE', minDigits: 9, maxDigits: 9, example: '498765432' },
  { code: '+55', country: 'Brazil', countryName: 'BR', minDigits: 10, maxDigits: 11, example: '11987654321' },
  { code: '+52', country: 'Mexico', countryName: 'MX', minDigits: 10, maxDigits: 10, example: '5551234567' },
  { code: '+54', country: 'Argentina', countryName: 'AR', minDigits: 10, maxDigits: 10, example: '1123456789' },
  { code: '+56', country: 'Chile', countryName: 'CL', minDigits: 9, maxDigits: 9, example: '912345678' },
  { code: '+57', country: 'Colombia', countryName: 'CO', minDigits: 10, maxDigits: 10, example: '3101234567' },
  { code: '+51', country: 'Peru', countryName: 'PE', minDigits: 9, maxDigits: 9, example: '912345678' },
  { code: '+27', country: 'South Africa', countryName: 'ZA', minDigits: 9, maxDigits: 9, example: '101234567' },
  { code: '+20', country: 'Egypt', countryName: 'EG', minDigits: 10, maxDigits: 10, example: '1001234567' },
  { code: '+234', country: 'Nigeria', countryName: 'NG', minDigits: 10, maxDigits: 10, example: '8012345678' },
  { code: '+212', country: 'Morocco', countryName: 'MA', minDigits: 9, maxDigits: 9, example: '612345678' },
  { code: '+60', country: 'Malaysia', countryName: 'MY', minDigits: 9, maxDigits: 10, example: '123456789' },
  { code: '+65', country: 'Singapore', countryName: 'SG', minDigits: 8, maxDigits: 8, example: '81234567' },
  { code: '+66', country: 'Thailand', countryName: 'TH', minDigits: 9, maxDigits: 9, example: '812345678' },
  { code: '+62', country: 'Indonesia', countryName: 'ID', minDigits: 10, maxDigits: 12, example: '8123456789' },
  { code: '+63', country: 'Philippines', countryName: 'PH', minDigits: 10, maxDigits: 10, example: '9171234567' },
  { code: '+82', country: 'South Korea', countryName: 'KR', minDigits: 10, maxDigits: 11, example: '1012345678' },
  { code: '+84', country: 'Vietnam', countryName: 'VN', minDigits: 9, maxDigits: 10, example: '912345678' },
  { code: '+64', country: 'New Zealand', countryName: 'NZ', minDigits: 9, maxDigits: 9, example: '201234567' },
  { code: '+966', country: 'Saudi Arabia', countryName: 'SA', minDigits: 9, maxDigits: 9, example: '501234567' },
  { code: '+971', country: 'United Arab Emirates', countryName: 'AE', minDigits: 9, maxDigits: 9, example: '501234567' },
  { code: '+90', country: 'Turkey', countryName: 'TR', minDigits: 10, maxDigits: 10, example: '5051234567' },
  { code: '+380', country: 'Ukraine', countryName: 'UA', minDigits: 9, maxDigits: 12, example: '501234567' },
  { code: '+48', country: 'Poland', countryName: 'PL', minDigits: 9, maxDigits: 9, example: '123456789' },
];

export const COUNTRIES = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'The Gambia',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

/**
 * Get country code by country name
 */
export const getCountryCode = (countryName) => {
  const entry = COUNTRY_CODES.find((c) => c.country === countryName);
  return entry?.code || '';
};

/**
 * Get all unique country codes
 */
export const getUniqueCountryCodes = () => {
  const codes = new Map();
  COUNTRY_CODES.forEach((entry) => {
    if (!codes.has(entry.code)) {
      codes.set(entry.code, entry.country);
    }
  });
  return Array.from(codes.entries()).map(([code, country]) => ({
    code,
    country,
  }));
};

/**
 * Get phone validation rules for a country code
 * Returns: { minDigits, maxDigits, example, country }
 */
export const getPhoneValidationRules = (countryCode) => {
  // Find the first matching country code entry (most common case)
  const entry = COUNTRY_CODES.find((c) => c.code === countryCode);
  if (entry) {
    return {
      minDigits: entry.minDigits,
      maxDigits: entry.maxDigits,
      example: entry.example,
      country: entry.country,
      countryName: entry.countryName,
    };
  }
  // Fallback for unknown country codes
  return {
    minDigits: 8,
    maxDigits: 15,
    example: '1234567890',
    country: 'Unknown',
    countryName: 'UN',
  };
};

/**
 * Validate phone number for a specific country code
 * Returns error message if invalid, null if valid
 */
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber?.trim()) {
    return null; // Phone is optional
  }

  const digits = phoneNumber.replace(/\s/g, '');

  // Must be digits only
  if (!/^\d+$/.test(digits)) {
    return 'Phone number must contain only digits';
  }

  const rules = getPhoneValidationRules(countryCode);
  const digitCount = digits.length;

  if (digitCount < rules.minDigits) {
    return `${rules.country} phone numbers must be at least ${rules.minDigits} digits (example: ${rules.example})`;
  }

  if (digitCount > rules.maxDigits) {
    return `${rules.country} phone numbers must be at most ${rules.maxDigits} digits (example: ${rules.example})`;
  }

  return null; // Valid
};
